import { AsyncPipe, DatePipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Input, } from '@angular/core';
import { bootstrapPersonRolodex } from '@ng-icons/bootstrap-icons';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { PanelModule } from 'primeng/panel';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { ITealCompClaim, TealCompClaim } from '../../../models/teal-comp-claim';
import { DialogModule } from 'primeng/dialog';
import { PartyEditorComponent } from '../../parties/party-editor/party-editor.component';
import { ClaimEditorComponent } from '../claim-editor/claim-editor.component';
import { IParty, Party } from '@harlowe/core';
import { instanceToInstance } from 'class-transformer';
import { ClaimService } from '../../../services/claim.service';
import { PartyService } from '@harlowe/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog'
import { Store } from '@ngxs/store';
import { Claims } from '../../../state/claims/claim-actions';
import { TableModule } from 'primeng/table';
import { Encounters } from '../../../state/encounters/encounter-actions';

@Component({
  selector: 'app-claim-card',
  standalone: true,
  imports: [NgIconComponent, NgIf, CardModule,ButtonModule, TieredMenuModule, PanelModule, 
            NgClass, DialogModule, PartyEditorComponent, ClaimEditorComponent,ConfirmDialogModule,
            DatePipe, TableModule, AsyncPipe, NgFor],
  templateUrl: './claim-card.component.html',
  styleUrl: './claim-card.component.scss',
  providers:[provideIcons({ bootstrapPersonRolodex })]

})
export class ClaimCardComponent
{
  
  @Input() showFullCard: boolean = false;
  @Input() claim : TealCompClaim | undefined;

  //Selected getter/setter
  private _selected: boolean = false;
  @Input() set selected (val : boolean)
  {
    this._selected = val;
    this.panelExpanded = val;

  }
  get selected() : boolean
  {
    return this._selected;
  }

  //Whether we see the menu options
  panelExpanded: boolean = false;

  editingParty: boolean = false;
  editingClaim: boolean = false;

  //Dialog Visibility variables
  partyDialogVisible: boolean = false;
  claimDialogVisible: boolean = false;
  
  
  partyForEdit?: Party;
  claimForEdit?: TealCompClaim;

  constructor
  (
    private _claimService: ClaimService,
    private _partyService: PartyService,
    private _confirmationService: ConfirmationService,
    private _store: Store
  )
  {

  }

  
  claimEncountersMenuItem: MenuItem =
  {
    label:'Encounters',
    iconClass: 'pi-spin',
    items: []
  };

  menuItems: MenuItem[] = 
  [
    {
      label:'Injured Worker Details',
      command: () => {this.cloneForEdit(this.claim?.party); this.partyDialogVisible = true;}
    },
    {
      label:'Claim Details',
      command: () => { this.cloneForEdit(this.claim); this.claimDialogVisible = true}

    },
    {
      label:'Services',
      command: () => this.loadClaimEncounters(),
      
      items:
      [
        {
          label:'Case Management',
          disabled: true
        },

        {
          label:'Bill Review',
          disabled: true
        },
        this.claimEncountersMenuItem
        
        
      ]
    },
    {
      separator:true
    },
    {
      label:'Close',
      icon: 'pi pi-times',
      command: () => this._confirmationService.confirm(this.closeConfirmationMessage)

    }
  ];

  loadClaimEncounters()
  {
    if(this.claim)
    {
      this.claimEncountersMenuItem.icon = 'pi pi-spinner'
      this._claimService.getClaimEncounters(this.claim.id).then
      (
        e => 
          {
            this.claimEncountersMenuItem.items = e.map( ee => {return {label: ee.id.toString(), command: () => this._store.dispatch(new Encounters.EncounterOpenedFromClaimCard({header:ee}))} as MenuItem});

            this.claimEncountersMenuItem.icon = undefined
            this.menuItems = [...this.menuItems];
          }
      )
    }
  }

  closeConfirmationMessage = 
  {
    // target: event.target as EventTarget,
    message: 'Closing this claim will also close all open encounters associated with it',
    header: 'Confirmation',
    icon: 'pi pi-exclamation-triangle',
    acceptIcon:"none",
    rejectIcon:"none",
    rejectButtonStyleClass:"p-button-text",
    acceptLabel:"Okay",
    rejectLabel:"Wait, No!",
    accept: () => 
    {
      if(this.claim)
        this._store.dispatch(new Claims.ClaimCardClaimClosed({claim:this.claim}));

    },
    reject: () => 
    {
    }
  };



  cloneForEdit<T>(value: T) : T
  {
    var clone = instanceToInstance(value);
    return clone;
  }

  async updateParty(party: IParty)
  {
    if(this.claim)
    {
      this.claim.party = Object.assign(this.claim.party, await this._partyService.updateParty(
        this.claim?.party.id,
        {
          id: this.claim?.party.id,
          dateOfBirth: party.dateOfBirth,
          firstName: party.firstName,
          lastName: party.lastName,
          optedInToStatusUpdates: party.optedInToStatusUpdates
        }
      ));
      this.partyForEdit = instanceToInstance(this.claim.party);
      this.editingParty = false;
    }

  }

  partyEditCancelled()
  {
    this.partyForEdit = undefined;
    this.editingParty = false;
  }

  editParty(event:MouseEvent)
  {
    this.partyForEdit = instanceToInstance(this.claim?.party);
    this.editingParty = true;
  }



  async updateClaim(claim: ITealCompClaim)
  {
    if(this.claim)
    {

      var c = await this._claimService.updateClaim(this.claim?.id,
        {
          id: this.claim?.id, 
          accidentDescription: claim.accidentDescription,
          adjusterId: claim.adjuster?.id,
          adjuster2Id: claim.adjuster2?.id,
          adjusterSupervisorId: claim.adjusterSupervisor?.id,
          adjustersToNotify: (claim as TealCompClaim).adjustersToNotifyIds,
          bodyPart: claim.bodyPart,
          carrierId: claim.carrier?.id,
          claimDate: claim.claimDate,
          claimNumber: claim.claimNumber,
          injuryDescription: claim.injuryDescription, 
          caseManager: claim.caseManager,
          contactInfo: claim.contactInfo
      }
    );
      this.claimForEdit = instanceToInstance(c);
      this.editingClaim = false;
    }

  }

  claimEditCancelled()
  {
    this.claimForEdit = undefined;
    this.editingClaim = false;
  }

  editClaim(event:MouseEvent)
  {
    this.claimForEdit = instanceToInstance(this.claim);
    this.editingClaim = true;
  }


}
